import React from 'react';
import createReactClass from 'create-react-class';

var FormRow = createReactClass({
  getDefaultProps(){
    return {
      width: 6,
    };
  },

  render() {
    let children = this.props.children;
    if(!Array.isArray(this.props.children)) {
      children = [children];
    }

    children = children.map((x, index) => (
      <section key={index} className={`col col-${this.props.width}`}>
        {x}
      </section>
    ));

    return (
      <div className="row">
        {children}
      </div>
    );
  }
});

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/common/Forms/FormRow.js